import { render, staticRenderFns } from "./dossiers.vue?vue&type=template&id=2f2a3ce5&scoped=true"
import script from "./dossiers.vue?vue&type=script&lang=js"
export * from "./dossiers.vue?vue&type=script&lang=js"
import style0 from "./dossiers.vue?vue&type=style&index=0&id=2f2a3ce5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f2a3ce5",
  null
  
)

export default component.exports